const initials = "order/";

export const UPDATE_ORDER = `${initials}UPDATE_ORDER`;
export const UPDATE_FILTER = `${initials}UPDATE_FILTER`;
export const UPDATE_REDUCER = `${initials}UPDATE_REDUCER`;
export const UPDATE_ORDER_PAPER = `${initials}UPDATE_ORDER_PAPER`;